import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RepositoryVehicleGroups } from "../../domain/repositories/repository-vehicle-groups";
import { type UUID } from "../../utils/uuid";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { FormUpdateVehicleGroup } from "../molecules/form-update-vehicle-group";

export type ListCommandButtonsVehicleGroupsProps = Omit<
    ListCommandButtonsProps<RepositoryVehicleGroups>,
    "list" | "createForm" | "listState"
>;

import { store } from "../../store";

@observer
export class ListCommandButtonsVehicleGroups extends React.Component<ListCommandButtonsVehicleGroupsProps> {
    constructor(props: ListCommandButtonsVehicleGroupsProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteVehicleGroups(ids: UUID[]): Promise<void> {
        await store.repositoryVehicleGroups.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }
    public render(): JSX.Element {
        return (
            <ListCommandButtons
                updateForm={FormUpdateVehicleGroup}
                {...this.props}
                listState={store.serviceListStates.vehicleGroups}
                onDelete={this.deleteVehicleGroups}
            />
        );
    }
}
